// extracted by mini-css-extract-plugin
export default {"search":"header-module--search--2xxDm","searchBox":"header-module--search-box--1svQb","brandLogo":"header-module--brand-logo--3ITRB"};